import './style.css';
import { Core } from './core/Core';

/**
 * Configuration
 * */
const canvas = document.querySelector('#main-canvas') as HTMLCanvasElement;
const sizes = {
	width: window.innerWidth,
	height: window.innerHeight,
};
const debugMode = window.location.search == '?debug';

/**
 * SETUP
 * */
new Core(canvas, sizes, debugMode);